/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
==========================================================================================*/

import unAuthActions from "./unAuthActions";

import authAdminPanelFirstScreenActions from "./authAdminPanelFirstScreenActions";

import profileActions from "./profileActions";

import organizationActions from "./organizationActions";
import usersActions from "./UsersActions";
import rolesActions from "./RolesActions";

import PageActions from "./PageActions";
import MenuActions from "./MenuActions";

import SearchActions from "./SearchActions";

import CartActions from "./CartActions";
import OrderActions from "./OrderActions";

import ProjectActions from "./ProjectActions";
import ProjectCategoryActions from "./ProjectCategoryActions";

import BlogPostActions from "./BlogPostActions";
import BlogCategoryActions from "./BlogCategoryActions";

import ShopProductActions from "./ShopProductActions";
import ShopCategoryActions from "./ShopCategoryActions";
import ShopShippingActions from "./ShopShippingActions";
import ShopDiscountCodeActions from "./ShopDiscountCodeActions";
import ShopOrderActions from "./ShopOrderActions";

import ServiceActions from "./ServiceActions";

import PartnerActions from "./PartnerActions";

import ReviewActions from "./ReviewActions";

import generalSettingsActions from "./GeneralSettingsActions";
import translationsActions from "./TranslationsActions";
import languagesActions from "./languagesActions";

import starredPages from "./starredPages";

import UiUx from "./UiUx";

import helperActions from "./helperActions";

import frontendActions from "./frontendActions";

const actions = Object.assign(
    unAuthActions,

    authAdminPanelFirstScreenActions,

    profileActions,

    organizationActions,
    usersActions,
    rolesActions,

    PageActions,
    MenuActions,

    SearchActions,

    CartActions,
    OrderActions,

    ProjectActions,
    ProjectCategoryActions,

    ShopProductActions,
    ShopCategoryActions,
    ShopShippingActions,
    ShopDiscountCodeActions,
    ShopOrderActions,

    BlogPostActions,
    BlogCategoryActions,

    ServiceActions,

    PartnerActions,

    ReviewActions,

    generalSettingsActions,
    translationsActions,
    languagesActions,

    starredPages,

    UiUx,

    helperActions,

    frontendActions
);

export default actions
